import type { ReactNode } from "react";
import "./SectionHeader.css";

interface SectionHeaderProps {
  title: ReactNode;
  // Right-hand side: a "view all" link, filters, etc.
  action?: ReactNode;
}

const SectionHeader = ({ title, action }: SectionHeaderProps) => (
  <div className="section-header">
    <h3 className="gradient-title section-header-title">{title}</h3>
    {action && <div className="section-header-action">{action}</div>}
  </div>
);

export default SectionHeader;
